(function () {
  'use strict';

  function isInPageAnchor(href) {
    return typeof href === 'string' && href.charAt(0) === '#' && href.length > 1;
  }

  function handleClick(event) {
    var link = event.currentTarget;
    var href = link.getAttribute('href');

    if (!isInPageAnchor(href)) return;

    var targetId = href.slice(1);
    var target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 90;

    window.scrollTo({
      top: top,
      behavior: prefersReduced ? 'auto' : 'smooth',
    });

    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    window.setTimeout(
      function () {
        target.focus({ preventScroll: true });
      },
      prefersReduced ? 0 : 500
    );
  }

  function initAll() {
    document.querySelectorAll('[data-banner-scroll-link]').forEach(function (link) {
      link.addEventListener('click', handleClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var links = event.target.querySelectorAll('[data-banner-scroll-link]');
    links.forEach(function (link) {
      link.addEventListener('click', handleClick);
    });
  });
})();
